import { render, staticRenderFns } from "./TestDisabledModal.vue?vue&type=template&id=4859bf79&scoped=true"
import script from "./TestDisabledModal.vue?vue&type=script&lang=js"
export * from "./TestDisabledModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859bf79",
  null
  
)

export default component.exports